import { Input, Select } from '@iwoca/orion';
import { FieldErrorsImpl, UseFormRegister } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { FormFieldError } from '../../../../../../forms/FormFieldError/FormFieldError';
import { titles } from '../../../../../../forms/nameField/Titles';
import messages from '../MSHForm.messages';
import { TFormValues } from '../MSHForm.types';
import styles from '../MSHModal.module.css';

const NameFields = ({
    errors,
    register,
    disabled
}: {
    errors: FieldErrorsImpl;
    register: UseFormRegister<TFormValues>;
    disabled: boolean;
}) => {
    const intl = useIntl();
    return (
        <div className={styles.fields}>
            {(errors.title || errors.firstName || errors.lastName) && (
                <FormFieldError message={messages.validNameRequired} />
            )}
            <label className={styles.label}>
                <FormattedMessage {...messages.nameFieldLabel} />
            </label>
            <Select
                {...register('title')}
                wrapperClassName={`${styles.title} ${styles.field}`}
                id="title"
                placeholder={intl.formatMessage(messages.titleFieldPlaceholder)}
                defaultValue={''}
                data-testid="title"
                disabled={disabled}
            >
                {titles.map(({ value, label }, index) => (
                    <option key={index + value} value={value}>
                        {label}
                    </option>
                ))}
            </Select>

            {/* eslint-disable-next-line iwoca/input-a11y */}
            <Input
                {...register('firstName', {
                    required: true
                })}
                wrapperClassName={`${styles.firstName} ${styles.field}`}
                id="firstName"
                placeholder={intl.formatMessage(
                    messages.firstNameFieldPlaceholder
                )}
                disabled={disabled}
            />
            {/* eslint-disable-next-line iwoca/input-a11y */}
            <Input
                {...register('lastName', {
                    required: true
                })}
                wrapperClassName={`${styles.lastName} ${styles.field}`}
                id="lastName"
                placeholder={intl.formatMessage(
                    messages.lastNameFieldPlaceholder
                )}
                disabled={disabled}
            />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default NameFields;
